// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ErrorText[data-v-b4a07e76]{color:#d32f2f;font-weight:700}.SelectedRow td[data-v-b4a07e76]{background-color:#fff3b0}.ReceiptFormula[data-v-b4a07e76]{margin-left:8px;font-weight:400;font-size:.85em}.FormulaToggle[data-v-b4a07e76]{margin-left:4px;font-weight:400;font-size:.75em}", ""]);
// Exports
module.exports = exports;
